import React from "react";

import "../../../styles/product-card.css";

import { Link } from "react-router-dom";

import { useDispatch } from "react-redux";
import { cartActions } from "../../../store/shopping-cart/cartSlice";

const ProductCard = (props) => {
  const { id, title, image01, price,desc } = props.item;
  const dispatch = useDispatch();

  const addToCart = () => {
    dispatch(
      cartActions.addItem({
        id,
        title,
        image01,
        price,
        desc,
      })
    );
  };

  return (
    <div className="product__item">
      <div className="product__img">
        <Link to={`/menu/${id}`}><img   src={image01} alt="product-img" className="w-100" /></Link>
       
      </div>

      <div className="product__content">
        <h5>
          <Link to={`/menu/${id}`}>{title}</Link>
        </h5>
        <h5>
          <Link to={`/menu/${id}`}>{desc}</Link>
        </h5>
        <div className=" d-flex align-items-center justify-content-between ">
          <span className="product__price">{price} so'mdan</span>
          <button className="addTOCart__btn" onClick={addToCart}>
            Savatga qo'shish
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
